import { createSelector } from "@reduxjs/toolkit";
import { ReduxState } from "../store";

export const selectLastModify = (state: ReduxState) => state.notification.lastModify;
export const selectNotifications = (state: ReduxState) => state.notification.notifications;
export const selectFetchingNotifications = (state: ReduxState) => state.notification.fetchingNotifications;

/** Newest first, the order the menu lists them in. */
export const selectSortedNotifications = createSelector(
    selectNotifications,
    notifications => [...notifications].sort((a, b) => new Date(b.modify).getTime() - new Date(a.modify).getTime()),
);

export const selectUnreadNotifications = createSelector(
    selectSortedNotifications,
    notifications => notifications.filter(({ seen }) => !seen),
);

export const selectUnreadNotificationsCount = createSelector(
    selectUnreadNotifications,
    notifications => notifications.length,
);
